import { css } from '@emotion/react';
import { GapUnits } from '../../types';
import { cssStringToBuilderReturnType } from '../commonUtils';
export const buildMasonryStyles = _ref => {
  let {
    selectors: {
      itemSelector,
      parentSelector
    },
    masonryDensity = 10,
    horizontalGap = 0,
    horizontalGapUnit = GapUnits.px,
    verticalGap = 0,
    verticalGapUnit = GapUnits.px
  } = _ref;
  const parentCss = css({
    [parentSelector]: {
      display: 'flex',
      flexWrap: 'wrap',
      columnGap: horizontalGap + horizontalGapUnit,
      rowGap: verticalGap + verticalGapUnit
    }
  }).styles;
  const itemCss = css({
    [`${itemSelector}:nth-child(n)`]: {
      height: masonryDensity * 2 + 'vh',
      flex: '1 1 auto'
    }
  }).styles;
  return cssStringToBuilderReturnType(parentCss + itemCss);
};
//# sourceMappingURL=masonryBuilder.js.map